<script>
    import { debounce } from "@/utils";
    import BaseInput from "@main/packages/BaseInput";
    import BaseTextarea from "@main/packages/BaseTextarea";

    export default {
        name: "GiftInfo",
        components: {
            BaseInput,
            BaseTextarea,
        },
        props: {
            errors: Object,
        },
        data() {
            return {
                form: {
                    sender: "",
                    recipient: "",
                    text: "",
                },
            };
        },
        watch: {
            form: {
                handler: debounce(function (value) {
                    this.$emit("on-update", value);
                }, 500),
                deep: true,
            },
        },
        methods: {
            resetError(name) {
                this.$emit("on-reset-error", { type: "formInfo", name });
            },
        },
    };
</script>

<template>
    <section id="gift-info" class="gift-info gift-section">
        <div class="gift-info__main">
            <h2 class="gift-section__title">Оформите сертификат</h2>
            <div class="gift-section__text">
                Эти данные получатель увидит в&nbsp;письме с&nbsp;сертификатом
            </div>

            <form class="gift-info__form">
                <div class="gift-info__input">
                    <base-input
                        v-model="form.sender"
                        name="sender"
                        variant="secondary"
                        placeholder="Имя отправителя"
                        :error-text="errors.sender"
                        @error="resetError"
                    ></base-input>
                </div>
                <div class="gift-info__input">
                    <base-input
                        v-model="form.recipient"
                        name="recipient"
                        variant="secondary"
                        placeholder="Имя получателя"
                        :error-text="errors.recipient"
                        @error="resetError"
                    ></base-input>
                </div>
                <div class="gift-info__input">
                    <base-textarea
                        v-model="form.text"
                        name="text"
                        variant="secondary"
                        placeholder="Текст вашего поздравления"
                        :max-length="250"
                    ></base-textarea>
                </div>
            </form>
        </div>

        <div class="gift-info__image">
            <img src="/static/madrobots/gift/info/image.png" alt="" />
        </div>
    </section>
</template>

<style lang="scss">
    .gift-info {
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
        }
    }

    .gift-info__main {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 480px;
            max-width: 480px;
            margin-bottom: 0;
        }
    }

    .gift-info__image {
        position: relative;
        margin-bottom: -20px;
        &::before {
            content: "";
            display: block;
            padding-bottom: 117.64%;
        }
        img {
            @include center-absolute(0);
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 400px;
            max-width: 400px;
            margin-bottom: -30px;
        }
        @include bp($bp-desktop-lg) {
            flex-basis: 480px;
            max-width: 480px;
            margin-bottom: -40px;
        }
    }

    .gift-info__form {
        @include bp($bp-desktop-sm) {
            max-width: 360px;
        }
    }

    .gift-info__input {
        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }
</style>
